module.exports = __webpack_public_path__ + "static/media/rom15.e6728430.jpg";